module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-19.c603b75d.jpg";